import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import config from "../../config"

import Header from './Header';
import Footer from './Footer';
import { useLocation, useNavigate } from 'react-router-dom';


const Channel_list = () => {
    const [state, setState] = React.useState([])
    const [statusState, setStatus] = React.useState(null)
    const { pathname,search } = useLocation();
    const query = new URLSearchParams(search);
    const status = query.get("status");
    const oauth = query.get("oauth");
    const reason = query.get("reason");
    const navigate = useNavigate();
  
    React.useEffect(() => {
        if (!status) return;
    
        const showAlert = async () => {
          if (status === "success") {
            await Swal.fire("✅ Store Integrated", "Your Shopify store was added successfully!", "success");
          } else if (status === "failed") {
            await Swal.fire("❌ Integration Failed", "Something went wrong during installation.", "error");
          }
          else if (status === "already_connected") {
            await Swal.fire("❌ Store already connected", "This Shopify store is already linked to any other account.", "error");
          }
         
          // Clean up the URL after alert
          navigate(pathname, { replace: true });
        };
    
        showAlert();
      }, [status, pathname, navigate]);


      React.useEffect(() => {
        if (!oauth) return;
    
        const showAlert = async () => {
          if (oauth === "success") {
            await Swal.fire("✅ Credentials Updated", "success");
          } else if (oauth === "failed") {
            await Swal.fire(`❌ ${reason}`, "Something went wrong during.", "error");
          }
          
         
          // Clean up the URL after alert
          navigate(pathname, { replace: true });
        };
    
        showAlert();
      }, [oauth, pathname, navigate]);

    React.useEffect(() => {
        getChannelList()
    }, [])
    const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000
    })
    const getChannelList = () => {


        let url = config.apiUrl + '/user/channel_list';
        let sendData = {};
        // console.log("bb", sendData);
        axios.post(url, sendData, { headers: config.headers }).then((res) => {
            // console.log("res ", res);  
            if (res.data.status == true) {
                setState(res.data.output)
            }
            else {
                Toast.fire({
                    background: "#a61c09",
                    type: 'unsuccess',
                    title: "Something Went Wrong",
                    color: "white"
                });
            }

        }).catch((e) => {
            Toast.fire({
                background: "#a61c09",
                type: 'unsuccess',
                title: "Something Went Wrong",
                color: "white"
            });

        });
    }
    const updateStatus = (status, store_id) => {


        let url = config.apiUrl + '/user/update_store_status';
        let sendData = { status: status, store_id: store_id };
        // console.log("bb", sendData);
        axios.post(url, sendData, { headers: config.headers }).then((res) => {
            if (res.data.status == true) {
                Toast.fire({
                    background: "#3659cd",
                    type: 'unsuccess',
                    title: "Updated Successfully",
                    color: "white"
                });
            }

        }).catch((e) => {

            Toast.fire({
                background: "#a61c09",
                type: 'unsuccess',
                title: "Something Went Wrong",
                color: "white"
            });
        });
    }

    const handleChange = (e, store_id) => {
        // console.log("e ", e.target.name);
        // console.log("e checked", e.target.checked);
        if (e.target.checked == true) {
            setStatus({ ...statusState, status: 1 })
            updateStatus(1, store_id)
        }
        else {
            setStatus({ ...statusState, status: 0 })
            updateStatus(0, store_id)

        }
    }
    const updateStoreField = (store_id, key, value) => {
        setState((prev) =>
          prev.map((s) =>
            s.store_id === store_id ? { ...s, [key]: value } : s
          )
        );
      };
      const startShopifyOAuth = (store_id, shop, client_id , client_secret) => {
        if (!shop || !client_id || !client_secret) {
          return Swal.fire("Error", "Shop , Client ID & Client Secret required", "error");
        }

        
        let full_api = config.apiUrl + '/user/save_shopify_oauth_creds';
        let sendData = {  store_id: store_id , client_id:client_id , client_secret:client_secret , shop: shop };
        // console.log("bb", sendData);
        axios.post(full_api, sendData, { headers: config.headers }).then((res) => {
            if (res.data.status == true) {
                const redirectUri = encodeURIComponent(
                    "https://skyshipbackend.fniix.com/auth/shopify/callback"
                  );
                
                  const scopes = encodeURIComponent(
                    "write_assigned_fulfillment_orders, read_assigned_fulfillment_orders, write_draft_orders, read_draft_orders, write_fulfillments, read_fulfillments, write_merchant_managed_fulfillment_orders, read_merchant_managed_fulfillment_orders, write_inventory, read_inventory, write_orders, read_orders, write_products, read_products, write_product_listings, read_product_listings, write_product_feeds, read_product_feeds"
                  );
                
                  const state = store_id;
                
                  const url = `https://${shop}/admin/oauth/authorize?client_id=${client_id}&scope=${scopes}&redirect_uri=${redirectUri}&state=${state}`;
                
                  window.location.href = url;
            }

        }).catch((e) => {

            Toast.fire({
                background: "#a61c09",
                type: 'unsuccess',
                title: "Something Went Wrong",
                color: "white"
            });
        });
      
       
      };
    return (
        <div>
            <Header />
            <div class="page-wrapper pinned">
                <div class="main-container">
                    <div className='app-container'>
                        <div class="app-body">
                            <div class="container-fluid">

                                <div class="mob_nav">
                                    <div class=" d-flex justify-content-start ">
                                        <a href="javascript:window.history.back();" class=""><i class="bi bi-arrow-left"></i></a>
                                        <h2>Channel List</h2>
                                    </div>
                                </div>


                                <div class="row justify-content-between">
                                    <div class="col-12 col-md-4 desk_nav">
                                        <div class="d-flex">
                                            <a href="javascript:window.history.back();" class="back_btn"><i class="bi bi-arrow-90deg-left"></i></a>
                                            <h2>Channel List</h2>
                                        </div>
                                    </div>

                                </div>
                                <div class="row justify-content-between">
                                    <div class="col-12 col-md">
                                        {state.length > 0 ?
                                            state.map((item) => (
                                                <div class="row channel_listing">
                                                    <div class="col-12 col-md-12 mb-3">
                                                        <div class={`card border  ${item.status == 5 ? "border-warning" : "border-success"}`}>
                                                            <div class="card-body">
                                                                <div class="row">
                                                                    <div class="col-12 col-md-1">
                                                                        <figure>
                                                                            {item.channel_id=="1567898605"?
                                                                            <img src="assets/img/shopify.png" class="img-fluid" />
                                                                            :<img src="assets/img/woo.png" class="img-fluid" />}
                                                                        </figure>
                                                                    </div>
                                                                    <div class="col-12 col-md">
                                                                        <h4>{item.store_name}  </h4>
                                                                        <p>Store ID: #{item.store_id} </p>
                                                                        <p>Store url: {item.store_url} </p>
                                                                   {item.channel_id=="1567898605"?     <p>Webhook Url: {item.webhook_url?item.webhook_url:""} </p>:""}<br/>
                                                                   {item.channel_id=="1567898605"? <>
                                                                        <h3> Create Webhook (Mandatory)</h3>
      <p>
        After installing the app, create a webhook in Shopify using the URL
        below:
      </p>

                                                            
                                                            <ul>
                                                            <li>Login into Shopify Admin panel</li>
                                                            <li>
          Open{" "}
          <a
            href="https://admin.shopify.com"
            target="_blank"
            rel="noreferrer"
          >
            https://admin.shopify.com
          </a>
        </li>
                                                                <li>In the Shopify Admin panel, go to <strong>Settings</strong>.</li>
                                                                <li>Click on <strong>Notifications</strong> from the left-hand menu.</li>
                                                                <li>Scroll down to the <strong>Webhooks</strong> section and click on <strong>Create Webhook</strong>.</li>
                                                                <li>
                                                                    In the popup:
                                                                    <ul>
                                                                        <li>Select the <strong>Event</strong> for which you want the webhook (e.g., Order Creation).</li>
                                                                        <li>Choose the <strong>Format</strong> (JSON is recommended).</li>
                                                                        <li>
                                                                            In the <strong>URL</strong> field, paste the Webhook URL provided:
                                                                            <br />
                                                                            <code style={{ display: "block", marginBottom: 8 }}>
        {/* {webhookUrl} */}{item.webhook_url?item.webhook_url:""}
      </code>
                                                                        </li>
                                                                    </ul>
                                                                </li>
                                                                <li>Click <strong>Save</strong>.</li>
                                                                <li>Your webhook is now active.</li>
                                                            </ul>
                                                            {item.store_api_key== undefined || item.store_api_key==""?
                                                            <div style={{ marginTop: 10, border: "1px solid #ddd", padding: 10 }}>
                                                            <h5>App Credentials</h5>

<p style={{ fontSize: 13, color: "#555" }}>
  This is a one-time setup and is required for:
</p>
<ul style={{ fontSize: 13, color: "#555" }}>
  <li>Auto update tracking numbers in Shopify</li>
  <li>Mark orders as fulfilled automatically</li>
</ul>

<p style={{ fontSize: 13, color: "#555" }}>
  To continue, please fill in your <b>Store URL</b>, <b>Client ID</b>, and{" "}
  <b>Client Secret</b>.
</p>

<p style={{ fontSize: 13, color: "#555" }}>
  We have already shown your <b>Store URL</b> above. Please fill that Store
  URL .
</p>

<p style={{ fontSize: 13, color: "#555" }}>
  To get your <b>Client ID</b> and <b>Client Secret</b>:
</p>
<ol style={{ fontSize: 13, color: "#555" }}>
  <li>Go to Shopify Partners Dashboard</li>
  <li>Click on <b>App distribution</b> → <b>All apps</b></li>
  <li>Click on <b>View on Dev Dashboard</b> for your app</li>
  <li>Go to <b>Settings</b> of that app</li>
  <li>You will see your <b>Client ID</b> and <b>Client Secret</b> there</li>
</ol>

    <input
      className="form-control mb-2"
      placeholder="Shopify Store URL (example.myshopify.com)"
      value={item.shop_input || ""}
      onChange={(e) =>
        updateStoreField(item.store_id, "shop_input", e.target.value)
      }
    />

    <input
      className="form-control mb-2"
      placeholder="Client ID"
      value={item.client_id_input || ""}
      onChange={(e) =>
        updateStoreField(item.store_id, "client_id_input", e.target.value)
      }
    />

    <input
      className="form-control mb-2"
      placeholder="Client Secret"
      value={item.client_secret_input || ""}
      onChange={(e) =>
        updateStoreField(item.store_id, "client_secret_input", e.target.value)
      }
    />

    <button
      className="btn btn-sm btn-success"
      onClick={() =>
        startShopifyOAuth(
          item.store_id,
          item.shop_input,
          item.client_id_input,
          item.client_secret_input
        )
      }
    >
      Submit
    </button>
  </div>:""}
                                                            </>:""}
                                                                    </div>
                                                                    <div class="col-12 col-md-3 text-end">
                                                                        <span class={`badge rounded-pill ${item.status == 5 ? "warning" : "bg-success"}`}><small>{item.status == 5 ? "Pending" : "Active"}</small></span>
                                                                    </div>
                                                                </div>
                                                                <hr />
                                                                <div class="row">
                                                                    {/* <div class="col-12 col-md-11">
                            <a href="#" class="btn btn-sm btn-secondary-o"><i class="bi bi-gear"></i> Connections</a>
                        </div> */}

                                                                    <div class="col-12 col-md-1 text-end">
                                                                        <div class="form-check form-switch  mb-2">
                                                                            {/* <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked=""/> */}
                                                                            {/* {item.channel_id=="1507808901"?
                                        
                                        <a class="nav-link text-danger" href={`/channel_integrate/${item.channel_id}?user_id=${item.unique_user}`} data-bs-toggle="tooltip" title="Unlink Store"><i class="material-icons-outlined">edit</i></a>
                                 
                                    :""} */}
                                                                        </div>

                                                                        {item.status != 5 ?
                                                                            <div class="form-check form-switch  mb-2">
                                                                                <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" defaultChecked={item.status} onChange={(e) => handleChange(e, item.store_id)} name="status" />
                                                                                <label class="form-check-label" for="flexSwitchCheckChecked"><small>Active/Inactive</small></label>
                                                                            </div>
                                                                            : ""}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>)) : ""}
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <h4>Available Integrations</h4>
                                        <div class="row mb-3 integration_bx ">
                                            <div class="col-12 shopify_bx mb-3">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <div class="row justify-content-between">
                                                            <div class="col-12 col-md-4">
                                                                <figure>
                                                                    <img src="assets/img/shopify.png" class="img-fluid" />
                                                                </figure>
                                                            </div>
                                                            <div class="col-12 col-md-8 py-4">
                                                                <div class="d-grid">
                                                                    <a href="/shopify_connect" class="btn btn-shopify btn-block btn-lg">Connect Store <i class="bi bi-arrow-right"></i></a>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 woocommerce_bx">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <div class="row justify-content-between">
                                                            <div class="col-12 col-md-4">
                                                                <figure>
                                                                    <img src="assets/img/woo.png" class="img-fluid" />
                                                                </figure>
                                                            </div>
                                                            <div class="col-12 col-md-8 py-4">
                                                                <div class="d-grid">
                                                                    <a href="/channel_integrate/1507808901" class="btn btn-woocommerce btn-block btn-lg">Connect Store <i class="bi bi-arrow-right"></i></a>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* {state.length>0?
                 state.map((item)=>(
    <section>
        <div class="row channel_listing">
            <div class="col-12 col-md-6 mb-3">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-md-2">
                            <figure>
                                <img src={`https://cdn.shipuncle.in/channel_images/${item.channel_img}`} class="img-fluid" />
                            </figure>
                        </div>
                        <div class="col-12 col-md">
                            <h4>{item.store_name} </h4>
                            <p>Store ID: #{item.store_id}</p>
                            <p>Store url: {item.store_url}</p>
                        </div>
                        <div class="col-12 col-md-3">
                            <span class="badge rounded-pill bg-danger"><small>{item.status==5?"Pending":""}</small></span>
                        </div>
                    </div>
                    <hr />
                    <div class="row">
                       
                        <div class="col-12 col-md text-end">
                            <div class="d-flex justify-content-end">
                                <div class="">
                                    
                                    {item.channel_id=="1507808901"?
                                        
                                        <a class="nav-link text-danger" href={`/channel_integrate/${item.channel_id}?user_id=${item.unique_user}`} data-bs-toggle="tooltip" title="Unlink Store"><i class="material-icons-outlined">edit</i></a>
                                 
                                    :""}
                                </div>
                                
                                <div class="ps-2 ">
                                {item.status!=5?
                                    <div class="form-check form-switch  mb-2">
                                        <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" defaultChecked={item.status} onChange={(e)=>handleChange(e , item.store_id)} name="status"/>
                                        <label class="form-check-label" for="flexSwitchCheckChecked"><small>Active/Inactive</small></label>
                                     </div>
                                     :""}
                                  
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>
                </div>
            </div>
           
        </div>
    </section>
                 )):""} */}

                            </div></div>
                        <Footer />
                    </div></div></div>
        </div>
    )
}

export default Channel_list
